export default {
  meta: {
    title: '供应商详情'
  }
};
